"use client";

import { PreviewMessage, ThinkingMessage } from "./message";
import { memo } from "react";
import equal from "fast-deep-equal";
import type { UIArtifact } from "./artifact";
import type { UseChatHelpers } from "@ai-sdk/react";
import { motion } from "framer-motion";
import { useMessages } from "@/hooks/use-messages";
import type { ChatMessage } from "@/types";
// import { ChevronDown } from "./icons";
import { ChevronDown, MoreHorizontal } from "lucide-react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "./ui/dropdown-menu";
import { setActiveTab } from "@/store/mainSlice";
import { useSelector, useDispatch } from "react-redux";

interface ArtifactMessagesProps {
  chatId: string;
  status: UseChatHelpers<ChatMessage>["status"];
  messages: ChatMessage[];
  setMessages: UseChatHelpers<ChatMessage>["setMessages"];
  regenerate: UseChatHelpers<ChatMessage>["regenerate"];
  isReadonly: boolean;
  artifactStatus: UIArtifact["status"];
  showCode: boolean;
}

function PureArtifactMessages({
  chatId,
  status,
  messages,
  setMessages,
  regenerate,
  isReadonly,
  showCode,
}: ArtifactMessagesProps) {
  const {
    containerRef: messagesContainerRef,
    endRef: messagesEndRef,
    onViewportEnter,
    onViewportLeave,
    hasSentMessage,
  } = useMessages({
    chatId,
    status,
  });
        const dispatch = useDispatch();
        const { activeTab } = useSelector((state) => state.main);
  return (
    <div
      ref={messagesContainerRef}
      className="flex flex-col gap-4 h-full items-start overflow-y-scroll px-4"
    >
      <div className="border-b border-white/10   flex justify-between items-center gap-2 w-full sticky top-0 dark:bg-sidebar bg-white  pt-2 z-10">
        <h2 className="text-[16px] leading-[1.25] dark:text-white text-black flex items-center gap-2 leading-[2]">
          {activeTab}
          <span></span>
        </h2>
      </div>
      {messages.map((message, index) => (
        <>
          <PreviewMessage
            chatId={chatId}
            key={message.id}
            message={message}
            isLoading={status === "streaming" && index === messages.length - 1}
            setMessages={setMessages}
            regenerate={regenerate}
            isReadonly={isReadonly}
            requiresScrollPadding={
              hasSentMessage && index === messages.length - 1
            }
            showCode={showCode}
          />
        </>
      ))}

      {status === "submitted" &&
        messages.length > 0 &&
        messages[messages.length - 1].role === "user" && <ThinkingMessage />}

      <motion.div
        ref={messagesEndRef}
        className="shrink-0 min-w-[24px] min-h-[24px]"
        onViewportLeave={onViewportLeave}
        onViewportEnter={onViewportEnter}
      />
    </div>
  );
}

function areEqual(
  prevProps: ArtifactMessagesProps,
  nextProps: ArtifactMessagesProps
) {
  // console.log(prevProps.messages,nextProps.messages,"uuuuuuuuuuuu")
  if (
    prevProps.artifactStatus === "streaming" &&
    nextProps.artifactStatus === "streaming"
  )
    return true;

  if (prevProps.status !== nextProps.status) return false;
  if (prevProps.status && nextProps.status) return false;
  if (prevProps.messages.length !== nextProps.messages.length) return false;

  return true;
}

export const ArtifactMessages = memo(PureArtifactMessages, areEqual);
